import { ElementRef, QueryList } from '@angular/core';

export class PredictiveSearchAccessibility {
  private activeOptionIndex = -1;
  constructor(private listOptions: QueryList<ElementRef>) {}

  handleKeyDown(
    event: KeyboardEvent,
    selectOption: (index: number) => void
  ): void {
    const listItems = this.listOptions.toArray();
    const lastIndex = listItems.length - 1;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.setListOptionsFocus(
          this.onArrowDown(this.activeOptionIndex, lastIndex)
        );

        break;
      case 'ArrowUp':
        event.preventDefault();
        this.setListOptionsFocus(
          this.onArrowUp(this.activeOptionIndex, lastIndex)
        );
        break;
      case 'Enter':
        event.preventDefault();
        this.onEnter(this.activeOptionIndex, selectOption);
        break;
    }
  }

  setListOptionsFocus(index: number) {
    this.activeOptionIndex = index;
    const listItems = this.listOptions.toArray();

    if (listItems[index]) {
      listItems[index].nativeElement.focus();
    }
  }

  onEnter(activeIndex: number, selectOption: (index: number) => void) {
    if (activeIndex > -1) {
      selectOption(activeIndex);
    }
  }

  onArrowUp(activeIndex: number, lastIndex: number) {
    return activeIndex > 0 ? activeIndex - 1 : lastIndex;
  }

  onArrowDown(activeIndex: number, lastIndex: number) {
    return activeIndex < lastIndex ? activeIndex + 1 : 0;
  }

  handleInputKeydown(
    event: KeyboardEvent,
    selectOption: (index: number) => void
  ) {
    this.handleKeyDown(event, selectOption);
  }

  checkInvalidInput(searchText: string) {
    const alphabetRegex = /^[a-zA-Z.\s]+$/;
    return !alphabetRegex.test(searchText);
  }

  reset(): void {
    this.activeOptionIndex = -1;
  }
}
